document.addEventListener('DOMContentLoaded', function() {
  const container = document.getElementById('evento-fields');
  const selectTipoEvento = document.getElementById('evento_tipo_evento');
  const notaFiscalSelector = document.getElementById('nota_fiscal_selector');
  const compraSelector = document.getElementById('compra_selector');

  if (!container || !selectTipoEvento) return;

  const initialDataPrevisao = container.dataset.initialDataPrevisao || "";
  const initialIndicadorQuitacao = container.dataset.initialIndicadorQuitacao || "1";
  const initialIndicadorAceitacao = container.dataset.initialIndicadorAceitacao || "";
  const initialEventoId = container.dataset.initialEventoId || "";
  const initialPerecimentoId = container.dataset.initialPerecimentoId || "";
  const initialFornecimentoId = container.dataset.initialFornecimentoId || "";
  const initialPerecimentoAdquirenteId = container.dataset.initialPerecimentoAdquirenteId || "";
  const initialImobilizacaoId = container.dataset.initialImobilizacaoId || "";
  const itensNotaFiscalUrl = container.dataset.itensNotaFiscalUrl || "";
  const itensCompraUrl = container.dataset.itensCompraUrl || "";
  const i18nPerecimento = {
    informacaoTitulo: container.dataset.i18nPerecimentoInformacaoTitulo || "",
    informacaoEvento: container.dataset.i18nPerecimentoInformacaoEvento || "",
    numeroItem: container.dataset.i18nPerecimentoNumeroItem || "",
    quantidadeAfetada: container.dataset.i18nPerecimentoQuantidadeAfetada || "",
    unidade: container.dataset.i18nPerecimentoUnidade || "",
    valorIbs: container.dataset.i18nPerecimentoValorIbs || "",
    valorCbs: container.dataset.i18nPerecimentoValorCbs || "",
    adicionarItem: container.dataset.i18nPerecimentoAdicionarItem || "",
    removerItem: container.dataset.i18nPerecimentoRemoverItem || "",
    selecioneItem: container.dataset.i18nPerecimentoSelecioneItem || "",
    selecioneNotaPrimeiro: container.dataset.i18nPerecimentoSelecioneNotaPrimeiro || ""
  };
  const i18nFornecimento = {
    informacaoTitulo: container.dataset.i18nFornecimentoInformacaoTitulo || "",
    informacaoEvento: container.dataset.i18nFornecimentoInformacaoEvento || "",
    numeroItem: container.dataset.i18nFornecimentoNumeroItem || "",
    quantidadeNaoFornecida: container.dataset.i18nFornecimentoQuantidadeNaoFornecida || "",
    unidade: container.dataset.i18nFornecimentoUnidade || "",
    valorIbs: container.dataset.i18nFornecimentoValorIbs || "",
    valorCbs: container.dataset.i18nFornecimentoValorCbs || "",
    adicionarItem: container.dataset.i18nFornecimentoAdicionarItem || "",
    removerItem: container.dataset.i18nFornecimentoRemoverItem || "",
    selecioneItem: container.dataset.i18nFornecimentoSelecioneItem || "",
    selecioneNotaPrimeiro: container.dataset.i18nFornecimentoSelecioneNotaPrimeiro || ""
  };
  const i18nPerecimentoAdquirente = {
    informacaoTitulo: container.dataset.i18nPerecimentoAdquirenteInformacaoTitulo || "",
    informacaoEvento: container.dataset.i18nPerecimentoAdquirenteInformacaoEvento || "",
    numeroItem: container.dataset.i18nPerecimentoAdquirenteNumeroItem || "",
    quantidadeAfetada: container.dataset.i18nPerecimentoAdquirenteQuantidadeAfetada || "",
    unidade: container.dataset.i18nPerecimentoAdquirenteUnidade || "",
    valorIbs: container.dataset.i18nPerecimentoAdquirenteValorIbs || "",
    valorCbs: container.dataset.i18nPerecimentoAdquirenteValorCbs || "",
    adicionarItem: container.dataset.i18nPerecimentoAdquirenteAdicionarItem || "",
    removerItem: container.dataset.i18nPerecimentoAdquirenteRemoverItem || "",
    selecioneItem: container.dataset.i18nPerecimentoAdquirenteSelecioneItem || "",
    selecioneNotaPrimeiro: container.dataset.i18nPerecimentoAdquirenteSelecioneNotaPrimeiro || ""
  };
  const i18nImobilizacao = {
    informacaoTitulo: container.dataset.i18nImobilizacaoInformacaoTitulo || "",
    informacaoEvento: container.dataset.i18nImobilizacaoInformacaoEvento || "",
    numeroItem: container.dataset.i18nImobilizacaoNumeroItem || "",
    quantidadeAfetada: container.dataset.i18nImobilizacaoQuantidadeAfetada || "",
    unidade: container.dataset.i18nImobilizacaoUnidade || "",
    valorIbs: container.dataset.i18nImobilizacaoValorIbs || "",
    valorCbs: container.dataset.i18nImobilizacaoValorCbs || "",
    adicionarItem: container.dataset.i18nImobilizacaoAdicionarItem || "",
    removerItem: container.dataset.i18nImobilizacaoRemoverItem || "",
    selecioneItem: container.dataset.i18nImobilizacaoSelecioneItem || "",
    selecioneNotaPrimeiro: container.dataset.i18nImobilizacaoSelecioneNotaPrimeiro || ""
  };
  const i18nForm = {
    selecioneTipoEvento: container.dataset.i18nSelecioneTipoEvento || "",
    tipoEventoInvalido: container.dataset.i18nTipoEventoInvalido || ""
  };

  function parseJsonDataset(valor) {
    try {
      return JSON.parse(valor || "[]");
    } catch (erro) {
      return [];
    }
  }

  function itemPerecimentoVazio() {
    return { id: "", numeroItem: "", quantidade: "", unidade: "", valorIbs: "", valorCbs: "" };
  }

  let itensNotaFiscal = parseJsonDataset(container.dataset.itensNotaFiscal);
  let perecimentoItens = parseJsonDataset(container.dataset.initialPerecimentoItens).map(function(item) {
    return {
      id: item.id || "",
      numeroItem: item.numero_item || "",
      quantidade: item.quantidade || "",
      unidade: item.unidade || "",
      valorIbs: item.valor_ibs || "",
      valorCbs: item.valor_cbs || ""
    };
  });
  let perecimentoItensRemovidos = [];
  if (!perecimentoItens.length) perecimentoItens.push(itemPerecimentoVazio());

  function itemFornecimentoVazio() {
    return { id: "", numeroItem: "", quantidade: "", unidade: "", valorIbs: "", valorCbs: "" };
  }

  let itensCompra = parseJsonDataset(container.dataset.itensCompra);
  let fornecimentoItens = parseJsonDataset(container.dataset.initialFornecimentoItens).map(function(item) {
    return {
      id: item.id || "",
      numeroItem: item.numero_item || "",
      quantidade: item.quantidade || "",
      unidade: item.unidade || "",
      valorIbs: item.valor_ibs || "",
      valorCbs: item.valor_cbs || ""
    };
  });
  let fornecimentoItensRemovidos = [];
  if (!fornecimentoItens.length) fornecimentoItens.push(itemFornecimentoVazio());

  let perecimentoAdquirenteItens = parseJsonDataset(container.dataset.initialPerecimentoAdquirenteItens).map(function(item) {
    return {
      id: item.id || "",
      numeroItem: item.numero_item || "",
      quantidade: item.quantidade || "",
      unidade: item.unidade || "",
      valorIbs: item.valor_ibs || "",
      valorCbs: item.valor_cbs || ""
    };
  });
  let perecimentoAdquirenteItensRemovidos = [];
  if (!perecimentoAdquirenteItens.length) perecimentoAdquirenteItens.push(itemPerecimentoVazio());

  let imobilizacaoItens = parseJsonDataset(container.dataset.initialImobilizacaoItens).map(function(item) {
    return {
      id: item.id || "",
      numeroItem: item.numero_item || "",
      quantidade: item.quantidade || "",
      unidade: item.unidade || "",
      valorIbs: item.valor_ibs || "",
      valorCbs: item.valor_cbs || ""
    };
  });
  let imobilizacaoItensRemovidos = [];
  if (!imobilizacaoItens.length) imobilizacaoItens.push(itemPerecimentoVazio());

  function getDataPrevisaoEntregaHtml(dataValue, eventoId) {
    return `
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label" for="evento_data_previsao_entrega_attributes_data_previsao_entrega">
              Data Prevista de Entrega *
            </label>            
            <div class="input-group">
              <span class="input-group-addon">
                <i class="fa fa-calendar"></i>
              </span>
              <input type="text" 
                name="fiscal_nota_fiscal_evento[data_previsao_entrega_attributes][data_previsao_entrega]" 
                id="evento_data_previsao_entrega_attributes_data_previsao_entrega" 
                class="form-control" 
                placeholder="dd/mm/aaaa" 
                required 
                value="${dataValue}">
            </div>
            ${eventoId ? `<input type="hidden" name="fiscal_nota_fiscal_evento[data_previsao_entrega_attributes][id]" value="${eventoId}">` : ''}
          </div>
        </div>
      </div>
    `;
  }

  function getPagamentoIntegralHtml(indicadorValue, eventoId) {
    return `
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-info" role="alert">
            <i class="fa fa-info-circle"></i>
            <strong>Informação sobre o evento:</strong>
            Este evento registra que houve pagamento integral efetivo da operação, conforme a Reforma Tributária (Lei Complementar nº 214/2025) e a NT 2025.002-RTC. 
            A informação é utilizada para liberar o crédito presumido do adquirente.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label">
              Indicador de Quitação *
            </label>            
            <input type="hidden" 
                   name="fiscal_nota_fiscal_evento[pagamento_integral_attributes][indicador_quitacao]" 
                   id="evento_pagamento_integral_attributes_indicador_quitacao"
                   value="${indicadorValue}">
            <p class="form-control-static">
              <strong>1 - Quitação integral confirmada</strong>
              <br>
              <small class="text-muted">
                Este valor indica que o pagamento da operação foi realizado integralmente.
              </small>
            </p>
            ${eventoId ? `<input type="hidden" name="fiscal_nota_fiscal_evento[pagamento_integral_attributes][id]" value="${eventoId}">` : ''}
          </div>
        </div>
      </div>
    `;
  }

  function getAceiteDebitoApuracaoHtml(indicadorValue, eventoId) {
    const opcao0Selecionado = indicadorValue === "0" ? 'selected="selected"' : '';
    const opcao1Selecionado = indicadorValue === "1" ? 'selected="selected"' : '';
    return `
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-info" role="alert">
            <i class="fa fa-info-circle"></i>
            <strong>Informação sobre o evento:</strong>
            Este evento registra o aceite ou não aceite dos valores de uma nota de crédito para fins de apuração de IBS/CBS, conforme a Reforma Tributária (Lei Complementar nº 214/2025) e a NT 2025.002-RTC.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label" for="evento_aceite_debito_apuracao_attributes_indicador_aceitacao">
              Indicador de Aceitação *
            </label>            
            <select name="fiscal_nota_fiscal_evento[aceite_debito_apuracao_attributes][indicador_aceitacao]"
                    id="evento_aceite_debito_apuracao_attributes_indicador_aceitacao"
                    class="form-control"
                    required>
              <option value="">Selecione</option>
              <option value="0" ${opcao0Selecionado}>0 - Não aceite</option>
              <option value="1" ${opcao1Selecionado}>1 - Aceite</option>
            </select>
            ${eventoId ? `<input type="hidden" name="fiscal_nota_fiscal_evento[aceite_debito_apuracao_attributes][id]" value="${eventoId}">` : ''}
          </div>
        </div>
      </div>
    `;
  }

  function escaparHtml(valor) {
    return String(valor || "")
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function opcoesItensNotaFiscal(numeroSelecionado, selecioneItem = i18nPerecimento.selecioneItem, selecioneNotaPrimeiro = i18nPerecimento.selecioneNotaPrimeiro) {
    const prompt = itensNotaFiscal.length ? selecioneItem : selecioneNotaPrimeiro;
    const opcoes = itensNotaFiscal.map(function(itemNota) {
      const selecionado = String(itemNota.numero_item) === String(numeroSelecionado) ? 'selected="selected"' : '';
      const rotulo = `${itemNota.numero_item} - ${itemNota.codigo || ''} - ${itemNota.descricao || ''}`;
      return `<option value="${itemNota.numero_item}" data-unidade="${escaparHtml(itemNota.unidade)}" ${selecionado}>${escaparHtml(rotulo)}</option>`;
    }).join('');
    return `<option value="">${escaparHtml(prompt)}</option>${opcoes}`;
  }

  function getPerecimentoItemHtml(item, indice) {
    const idHidden = item.id
      ? `<input type="hidden" name="fiscal_nota_fiscal_evento[perecimento_attributes][itens_attributes][${indice}][id]" value="${escaparHtml(item.id)}">`
      : '';
    return `
      <div class="form-row perecimento-item">
        <div class="form-group col-md-4">
          <label class="control-label required" for="evento_perecimento_attributes_itens_attributes_${indice}_numero_item">
            ${i18nPerecimento.numeroItem} *
          </label>
          <select name="fiscal_nota_fiscal_evento[perecimento_attributes][itens_attributes][${indice}][numero_item]"
                  id="evento_perecimento_attributes_itens_attributes_${indice}_numero_item"
                  class="form-control perecimento-numero-item"
                  required>
            ${opcoesItensNotaFiscal(item.numeroItem)}
          </select>
        </div>
        <div class="form-group col-md-2">
          <label class="control-label required" for="evento_perecimento_attributes_itens_attributes_${indice}_quantidade_perecimento">
            ${i18nPerecimento.quantidadeAfetada} *
          </label>
          <input type="number"
                 name="fiscal_nota_fiscal_evento[perecimento_attributes][itens_attributes][${indice}][quantidade_perecimento]"
                 id="evento_perecimento_attributes_itens_attributes_${indice}_quantidade_perecimento"
                 class="form-control perecimento-quantidade"
                 step="0.0001"
                 min="0.0001"
                 required
                 value="${escaparHtml(item.quantidade)}">
        </div>
        <div class="form-group col-md-1">
          <label class="control-label required" for="evento_perecimento_attributes_itens_attributes_${indice}_unidade_perecimento">
            ${i18nPerecimento.unidade} *
          </label>
          <input type="text"
                 name="fiscal_nota_fiscal_evento[perecimento_attributes][itens_attributes][${indice}][unidade_perecimento]"
                 id="evento_perecimento_attributes_itens_attributes_${indice}_unidade_perecimento"
                 class="form-control perecimento-unidade"
                 maxlength="6"
                 required
                 value="${escaparHtml(item.unidade)}">
        </div>
        <div class="form-group col-md-2">
          <label class="control-label required" for="evento_perecimento_attributes_itens_attributes_${indice}_valor_ibs">
            ${i18nPerecimento.valorIbs} *
          </label>
          <input type="number"
                 name="fiscal_nota_fiscal_evento[perecimento_attributes][itens_attributes][${indice}][valor_ibs]"
                 id="evento_perecimento_attributes_itens_attributes_${indice}_valor_ibs"
                 class="form-control text-right perecimento-valor-ibs"
                 step="0.01"
                 min="0"
                 required
                 value="${escaparHtml(item.valorIbs)}">
        </div>
        <div class="form-group col-md-2">
          <label class="control-label required" for="evento_perecimento_attributes_itens_attributes_${indice}_valor_cbs">
            ${i18nPerecimento.valorCbs} *
          </label>
          <input type="number"
                 name="fiscal_nota_fiscal_evento[perecimento_attributes][itens_attributes][${indice}][valor_cbs]"
                 id="evento_perecimento_attributes_itens_attributes_${indice}_valor_cbs"
                 class="form-control text-right perecimento-valor-cbs"
                 step="0.01"
                 min="0"
                 required
                 value="${escaparHtml(item.valorCbs)}">
        </div>
        <div class="form-group col-md-1">
          <label class="control-label">&nbsp;</label>
          <button type="button"
                  class="btn btn-danger btn-block perecimento-remover-item"
                  title="${escaparHtml(i18nPerecimento.removerItem)}">
            <i class="fa fa-trash"></i>
          </button>
        </div>
        ${idHidden}
      </div>
    `;
  }

  function getPerecimentoHtml() {
    const linhas = perecimentoItens.map(getPerecimentoItemHtml).join('');
    const removidos = perecimentoItensRemovidos.map(function(itemId, posicao) {
      const indice = 9000 + posicao;
      return `
        <input type="hidden" name="fiscal_nota_fiscal_evento[perecimento_attributes][itens_attributes][${indice}][id]" value="${escaparHtml(itemId)}">
        <input type="hidden" name="fiscal_nota_fiscal_evento[perecimento_attributes][itens_attributes][${indice}][_destroy]" value="1">
      `;
    }).join('');
    const perecimentoIdHidden = initialPerecimentoId
      ? `<input type="hidden" name="fiscal_nota_fiscal_evento[perecimento_attributes][id]" value="${escaparHtml(initialPerecimentoId)}">`
      : '';
    return `
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-info" role="alert">
            <i class="fa fa-info-circle"></i>
            <strong>${i18nPerecimento.informacaoTitulo}</strong>
            ${i18nPerecimento.informacaoEvento}
          </div>
        </div>
      </div>
      <div id="perecimento-itens">${linhas}</div>
      <div class="form-row">
        <div class="form-group col-md-3">
          <button type="button" class="btn btn-default" id="perecimento-adicionar-item">
            <i class="fa fa-plus"></i> ${escaparHtml(i18nPerecimento.adicionarItem)}
          </button>
        </div>
      </div>
      ${removidos}
      ${perecimentoIdHidden}
    `;
  }

  function lerPerecimentoItensDoDom() {
    const linhas = container.querySelectorAll('.perecimento-item');
    if (!linhas.length) return;
    perecimentoItens = Array.from(linhas).map(function(linha) {
      const idHidden = linha.querySelector('input[name$="[id]"]');
      return {
        id: idHidden ? idHidden.value : "",
        numeroItem: linha.querySelector('.perecimento-numero-item').value,
        quantidade: linha.querySelector('.perecimento-quantidade').value,
        unidade: linha.querySelector('.perecimento-unidade').value,
        valorIbs: linha.querySelector('.perecimento-valor-ibs').value,
        valorCbs: linha.querySelector('.perecimento-valor-cbs').value
      };
    });
  }

  function renderPerecimento() {
    if (selectTipoEvento.value !== 'Fiscal::NotaFiscal::Evento::Perecimento') return;
    container.innerHTML = getPerecimentoHtml();
  }

  function resetPerecimentoItens() {
    perecimentoItens.forEach(function(item) {
      if (item.id) perecimentoItensRemovidos.push(item.id);
    });
    perecimentoItens = [itemPerecimentoVazio()];
  }

  function getFornecimentoItemHtml(item, indice) {
    const idHidden = item.id
      ? `<input type="hidden" name="fiscal_nota_fiscal_evento[fornecimento_nao_realizado_attributes][itens_attributes][${indice}][id]" value="${escaparHtml(item.id)}">`
      : '';
    return `
      <div class="form-row fornecimento-item">
        <div class="form-group col-md-4">
          <label class="control-label required" for="evento_fornecimento_nao_realizado_attributes_itens_attributes_${indice}_numero_item">
            ${i18nFornecimento.numeroItem} *
          </label>
          <select name="fiscal_nota_fiscal_evento[fornecimento_nao_realizado_attributes][itens_attributes][${indice}][numero_item]"
                  id="evento_fornecimento_nao_realizado_attributes_itens_attributes_${indice}_numero_item"
                  class="form-control fornecimento-numero-item"
                  required>
            ${opcoesItensNotaFiscal(item.numeroItem, i18nFornecimento.selecioneItem, i18nFornecimento.selecioneNotaPrimeiro)}
          </select>
        </div>
        <div class="form-group col-md-2">
          <label class="control-label required" for="evento_fornecimento_nao_realizado_attributes_itens_attributes_${indice}_quantidade_nao_fornecida">
            ${i18nFornecimento.quantidadeNaoFornecida} *
          </label>
          <input type="number"
                 name="fiscal_nota_fiscal_evento[fornecimento_nao_realizado_attributes][itens_attributes][${indice}][quantidade_nao_fornecida]"
                 id="evento_fornecimento_nao_realizado_attributes_itens_attributes_${indice}_quantidade_nao_fornecida"
                 class="form-control fornecimento-quantidade"
                 step="0.0001"
                 min="0.0001"
                 required
                 value="${escaparHtml(item.quantidade)}">
        </div>
        <div class="form-group col-md-1">
          <label class="control-label required" for="evento_fornecimento_nao_realizado_attributes_itens_attributes_${indice}_unidade_nao_fornecida">
            ${i18nFornecimento.unidade} *
          </label>
          <input type="text"
                 name="fiscal_nota_fiscal_evento[fornecimento_nao_realizado_attributes][itens_attributes][${indice}][unidade_nao_fornecida]"
                 id="evento_fornecimento_nao_realizado_attributes_itens_attributes_${indice}_unidade_nao_fornecida"
                 class="form-control fornecimento-unidade"
                 maxlength="6"
                 required
                 value="${escaparHtml(item.unidade)}">
        </div>
        <div class="form-group col-md-2">
          <label class="control-label required" for="evento_fornecimento_nao_realizado_attributes_itens_attributes_${indice}_valor_ibs">
            ${i18nFornecimento.valorIbs} *
          </label>
          <input type="number"
                 name="fiscal_nota_fiscal_evento[fornecimento_nao_realizado_attributes][itens_attributes][${indice}][valor_ibs]"
                 id="evento_fornecimento_nao_realizado_attributes_itens_attributes_${indice}_valor_ibs"
                 class="form-control text-right fornecimento-valor-ibs"
                 step="0.01"
                 min="0"
                 required
                 value="${escaparHtml(item.valorIbs)}">
        </div>
        <div class="form-group col-md-2">
          <label class="control-label required" for="evento_fornecimento_nao_realizado_attributes_itens_attributes_${indice}_valor_cbs">
            ${i18nFornecimento.valorCbs} *
          </label>
          <input type="number"
                 name="fiscal_nota_fiscal_evento[fornecimento_nao_realizado_attributes][itens_attributes][${indice}][valor_cbs]"
                 id="evento_fornecimento_nao_realizado_attributes_itens_attributes_${indice}_valor_cbs"
                 class="form-control text-right fornecimento-valor-cbs"
                 step="0.01"
                 min="0"
                 required
                 value="${escaparHtml(item.valorCbs)}">
        </div>
        <div class="form-group col-md-1">
          <label class="control-label">&nbsp;</label>
          <button type="button"
                  class="btn btn-danger btn-block fornecimento-remover-item"
                  title="${escaparHtml(i18nFornecimento.removerItem)}">
            <i class="fa fa-trash"></i>
          </button>
        </div>
        ${idHidden}
      </div>
    `;
  }

  function getFornecimentoNaoRealizadoHtml() {
    const linhas = fornecimentoItens.map(getFornecimentoItemHtml).join('');
    const removidos = fornecimentoItensRemovidos.map(function(itemId, posicao) {
      const indice = 9000 + posicao;
      return `
        <input type="hidden" name="fiscal_nota_fiscal_evento[fornecimento_nao_realizado_attributes][itens_attributes][${indice}][id]" value="${escaparHtml(itemId)}">
        <input type="hidden" name="fiscal_nota_fiscal_evento[fornecimento_nao_realizado_attributes][itens_attributes][${indice}][_destroy]" value="1">
      `;
    }).join('');
    const fornecimentoIdHidden = initialFornecimentoId
      ? `<input type="hidden" name="fiscal_nota_fiscal_evento[fornecimento_nao_realizado_attributes][id]" value="${escaparHtml(initialFornecimentoId)}">`
      : '';
    return `
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-info" role="alert">
            <i class="fa fa-info-circle"></i>
            <strong>${i18nFornecimento.informacaoTitulo}</strong>
            ${i18nFornecimento.informacaoEvento}
          </div>
        </div>
      </div>
      <div id="fornecimento-itens">${linhas}</div>
      <div class="form-row">
        <div class="form-group col-md-3">
          <button type="button" class="btn btn-default" id="fornecimento-adicionar-item">
            <i class="fa fa-plus"></i> ${escaparHtml(i18nFornecimento.adicionarItem)}
          </button>
        </div>
      </div>
      ${removidos}
      ${fornecimentoIdHidden}
    `;
  }

  function lerFornecimentoItensDoDom() {
    const linhas = container.querySelectorAll('.fornecimento-item');
    if (!linhas.length) return;
    fornecimentoItens = Array.from(linhas).map(function(linha) {
      const idHidden = linha.querySelector('input[name$="[id]"]');
      return {
        id: idHidden ? idHidden.value : "",
        numeroItem: linha.querySelector('.fornecimento-numero-item').value,
        quantidade: linha.querySelector('.fornecimento-quantidade').value,
        unidade: linha.querySelector('.fornecimento-unidade').value,
        valorIbs: linha.querySelector('.fornecimento-valor-ibs').value,
        valorCbs: linha.querySelector('.fornecimento-valor-cbs').value
      };
    });
  }

  function renderFornecimento() {
    if (selectTipoEvento.value !== 'Fiscal::NotaFiscal::Evento::FornecimentoNaoRealizado') return;
    container.innerHTML = getFornecimentoNaoRealizadoHtml();
  }

  function resetFornecimentoItens() {
    fornecimentoItens.forEach(function(item) {
      if (item.id) fornecimentoItensRemovidos.push(item.id);
    });
    fornecimentoItens = [itemFornecimentoVazio()];
  }

  function resetarItensEventoAtivo() {
    resetPerecimentoItens();
    resetFornecimentoItens();
  }

  function renderizarItensEventoAtivo() {
    renderPerecimento();
    renderFornecimento();
  }

  function aoTrocarNotaFiscal(notaFiscalId) {
    if (!itensNotaFiscalUrl || !notaFiscalId) {
      itensNotaFiscal = [];
      resetarItensEventoAtivo();
      renderizarItensEventoAtivo();
      return;
    }
    fetch(`${itensNotaFiscalUrl}?nota_fiscal_id=${encodeURIComponent(notaFiscalId)}`, { headers: { 'Accept': 'application/json' } })
      .then(function(resposta) { return resposta.ok ? resposta.json() : []; })
      .then(function(itens) {
        itensNotaFiscal = itens;
        resetarItensEventoAtivo();
        renderizarItensEventoAtivo();
      })
      .catch(function() {
        itensNotaFiscal = [];
        resetarItensEventoAtivo();
        renderizarItensEventoAtivo();
      });
  }

  function opcoesItensCompra(numeroSelecionado, selecioneItem = i18nPerecimentoAdquirente.selecioneItem, selecioneNotaPrimeiro = i18nPerecimentoAdquirente.selecioneNotaPrimeiro) {
    const prompt = itensCompra.length ? selecioneItem : selecioneNotaPrimeiro;
    const opcoes = itensCompra.map(function(itemCompra) {
      const selecionado = String(itemCompra.numero_item) === String(numeroSelecionado) ? 'selected="selected"' : '';
      const rotulo = `${itemCompra.numero_item} - ${itemCompra.codigo || ''} - ${itemCompra.descricao || ''}`;
      return `<option value="${itemCompra.numero_item}" data-unidade="${escaparHtml(itemCompra.unidade)}" ${selecionado}>${escaparHtml(rotulo)}</option>`;
    }).join('');
    return `<option value="">${escaparHtml(prompt)}</option>${opcoes}`;
  }

  function getPerecimentoAdquirenteItemHtml(item, indice) {
    const idHidden = item.id
      ? `<input type="hidden" name="fiscal_nota_fiscal_evento[perecimento_adquirente_attributes][itens_attributes][${indice}][id]" value="${escaparHtml(item.id)}">`
      : '';
    return `
      <div class="form-row perecimento-adquirente-item">
        <div class="form-group col-md-4">
          <label class="control-label required" for="evento_perecimento_adquirente_attributes_itens_attributes_${indice}_numero_item">
            ${i18nPerecimentoAdquirente.numeroItem} *
          </label>
          <select name="fiscal_nota_fiscal_evento[perecimento_adquirente_attributes][itens_attributes][${indice}][numero_item]"
                  id="evento_perecimento_adquirente_attributes_itens_attributes_${indice}_numero_item"
                  class="form-control perecimento-adquirente-numero-item"
                  required>
            ${opcoesItensCompra(item.numeroItem)}
          </select>
        </div>
        <div class="form-group col-md-2">
          <label class="control-label required" for="evento_perecimento_adquirente_attributes_itens_attributes_${indice}_quantidade_perecimento">
            ${i18nPerecimentoAdquirente.quantidadeAfetada} *
          </label>
          <input type="number"
                 name="fiscal_nota_fiscal_evento[perecimento_adquirente_attributes][itens_attributes][${indice}][quantidade_perecimento]"
                 id="evento_perecimento_adquirente_attributes_itens_attributes_${indice}_quantidade_perecimento"
                 class="form-control perecimento-adquirente-quantidade"
                 step="0.0001"
                 min="0.0001"
                 required
                 value="${escaparHtml(item.quantidade)}">
        </div>
        <div class="form-group col-md-1">
          <label class="control-label required" for="evento_perecimento_adquirente_attributes_itens_attributes_${indice}_unidade_perecimento">
            ${i18nPerecimentoAdquirente.unidade} *
          </label>
          <input type="text"
                 name="fiscal_nota_fiscal_evento[perecimento_adquirente_attributes][itens_attributes][${indice}][unidade_perecimento]"
                 id="evento_perecimento_adquirente_attributes_itens_attributes_${indice}_unidade_perecimento"
                 class="form-control perecimento-adquirente-unidade"
                 maxlength="6"
                 required
                 value="${escaparHtml(item.unidade)}">
        </div>
        <div class="form-group col-md-2">
          <label class="control-label required" for="evento_perecimento_adquirente_attributes_itens_attributes_${indice}_valor_ibs">
            ${i18nPerecimentoAdquirente.valorIbs} *
          </label>
          <input type="number"
                 name="fiscal_nota_fiscal_evento[perecimento_adquirente_attributes][itens_attributes][${indice}][valor_ibs]"
                 id="evento_perecimento_adquirente_attributes_itens_attributes_${indice}_valor_ibs"
                 class="form-control text-right perecimento-adquirente-valor-ibs"
                 step="0.01"
                 min="0"
                 required
                 value="${escaparHtml(item.valorIbs)}">
        </div>
        <div class="form-group col-md-2">
          <label class="control-label required" for="evento_perecimento_adquirente_attributes_itens_attributes_${indice}_valor_cbs">
            ${i18nPerecimentoAdquirente.valorCbs} *
          </label>
          <input type="number"
                 name="fiscal_nota_fiscal_evento[perecimento_adquirente_attributes][itens_attributes][${indice}][valor_cbs]"
                 id="evento_perecimento_adquirente_attributes_itens_attributes_${indice}_valor_cbs"
                 class="form-control text-right perecimento-adquirente-valor-cbs"
                 step="0.01"
                 min="0"
                 required
                 value="${escaparHtml(item.valorCbs)}">
        </div>
        <div class="form-group col-md-1">
          <label class="control-label">&nbsp;</label>
          <button type="button"
                  class="btn btn-danger btn-block perecimento-adquirente-remover-item"
                  title="${escaparHtml(i18nPerecimentoAdquirente.removerItem)}">
            <i class="fa fa-trash"></i>
          </button>
        </div>
        ${idHidden}
      </div>
    `;
  }

  function getPerecimentoAdquirenteHtml() {
    const linhas = perecimentoAdquirenteItens.map(getPerecimentoAdquirenteItemHtml).join('');
    const removidos = perecimentoAdquirenteItensRemovidos.map(function(itemId, posicao) {
      const indice = 9000 + posicao;
      return `
        <input type="hidden" name="fiscal_nota_fiscal_evento[perecimento_adquirente_attributes][itens_attributes][${indice}][id]" value="${escaparHtml(itemId)}">
        <input type="hidden" name="fiscal_nota_fiscal_evento[perecimento_adquirente_attributes][itens_attributes][${indice}][_destroy]" value="1">
      `;
    }).join('');
    const perecimentoIdHidden = initialPerecimentoAdquirenteId
      ? `<input type="hidden" name="fiscal_nota_fiscal_evento[perecimento_adquirente_attributes][id]" value="${escaparHtml(initialPerecimentoAdquirenteId)}">`
      : '';
    return `
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-info" role="alert">
            <i class="fa fa-info-circle"></i>
            <strong>${i18nPerecimentoAdquirente.informacaoTitulo}</strong>
            ${i18nPerecimentoAdquirente.informacaoEvento}
          </div>
        </div>
      </div>
      <div id="perecimento-adquirente-itens">${linhas}</div>
      <div class="form-row">
        <div class="form-group col-md-3">
          <button type="button" class="btn btn-default" id="perecimento-adquirente-adicionar-item">
            <i class="fa fa-plus"></i> ${escaparHtml(i18nPerecimentoAdquirente.adicionarItem)}
          </button>
        </div>
      </div>
      ${removidos}
      ${perecimentoIdHidden}
    `;
  }

  function lerPerecimentoAdquirenteItensDoDom() {
    const linhas = container.querySelectorAll('.perecimento-adquirente-item');
    if (!linhas.length) return;
    perecimentoAdquirenteItens = Array.from(linhas).map(function(linha) {
      const idHidden = linha.querySelector('input[name$="[id]"]');
      return {
        id: idHidden ? idHidden.value : "",
        numeroItem: linha.querySelector('.perecimento-adquirente-numero-item').value,
        quantidade: linha.querySelector('.perecimento-adquirente-quantidade').value,
        unidade: linha.querySelector('.perecimento-adquirente-unidade').value,
        valorIbs: linha.querySelector('.perecimento-adquirente-valor-ibs').value,
        valorCbs: linha.querySelector('.perecimento-adquirente-valor-cbs').value
      };
    });
  }

  function renderPerecimentoAdquirente() {
    if (selectTipoEvento.value !== 'Fiscal::NotaFiscal::Evento::PerecimentoAdquirente') return;
    container.innerHTML = getPerecimentoAdquirenteHtml();
  }

  function resetPerecimentoAdquirenteItens() {
    perecimentoAdquirenteItens.forEach(function(item) {
      if (item.id) perecimentoAdquirenteItensRemovidos.push(item.id);
    });
    perecimentoAdquirenteItens = [itemPerecimentoVazio()];
  }

  function getImobilizacaoItemHtml(item, indice) {
    const idHidden = item.id
      ? `<input type="hidden" name="fiscal_nota_fiscal_evento[imobilizacao_attributes][itens_attributes][${indice}][id]" value="${escaparHtml(item.id)}">`
      : '';
    return `
      <div class="form-row imobilizacao-item">
        <div class="form-group col-md-4">
          <label class="control-label required" for="evento_imobilizacao_attributes_itens_attributes_${indice}_numero_item">
            ${i18nImobilizacao.numeroItem} *
          </label>
          <select name="fiscal_nota_fiscal_evento[imobilizacao_attributes][itens_attributes][${indice}][numero_item]"
                  id="evento_imobilizacao_attributes_itens_attributes_${indice}_numero_item"
                  class="form-control imobilizacao-numero-item"
                  required>
            ${opcoesItensCompra(item.numeroItem, i18nImobilizacao.selecioneItem, i18nImobilizacao.selecioneNotaPrimeiro)}
          </select>
        </div>
        <div class="form-group col-md-2">
          <label class="control-label required" for="evento_imobilizacao_attributes_itens_attributes_${indice}_quantidade_imobilizada">
            ${i18nImobilizacao.quantidadeAfetada} *
          </label>
          <input type="number"
                 name="fiscal_nota_fiscal_evento[imobilizacao_attributes][itens_attributes][${indice}][quantidade_imobilizada]"
                 id="evento_imobilizacao_attributes_itens_attributes_${indice}_quantidade_imobilizada"
                 class="form-control imobilizacao-quantidade"
                 step="0.0001"
                 min="0.0001"
                 required
                 value="${escaparHtml(item.quantidade)}">
        </div>
        <div class="form-group col-md-1">
          <label class="control-label required" for="evento_imobilizacao_attributes_itens_attributes_${indice}_unidade_imobilizada">
            ${i18nImobilizacao.unidade} *
          </label>
          <input type="text"
                 name="fiscal_nota_fiscal_evento[imobilizacao_attributes][itens_attributes][${indice}][unidade_imobilizada]"
                 id="evento_imobilizacao_attributes_itens_attributes_${indice}_unidade_imobilizada"
                 class="form-control imobilizacao-unidade"
                 maxlength="6"
                 required
                 value="${escaparHtml(item.unidade)}">
        </div>
        <div class="form-group col-md-2">
          <label class="control-label required" for="evento_imobilizacao_attributes_itens_attributes_${indice}_valor_ibs">
            ${i18nImobilizacao.valorIbs} *
          </label>
          <input type="number"
                 name="fiscal_nota_fiscal_evento[imobilizacao_attributes][itens_attributes][${indice}][valor_ibs]"
                 id="evento_imobilizacao_attributes_itens_attributes_${indice}_valor_ibs"
                 class="form-control text-right imobilizacao-valor-ibs"
                 step="0.01"
                 min="0"
                 required
                 value="${escaparHtml(item.valorIbs)}">
        </div>
        <div class="form-group col-md-2">
          <label class="control-label required" for="evento_imobilizacao_attributes_itens_attributes_${indice}_valor_cbs">
            ${i18nImobilizacao.valorCbs} *
          </label>
          <input type="number"
                 name="fiscal_nota_fiscal_evento[imobilizacao_attributes][itens_attributes][${indice}][valor_cbs]"
                 id="evento_imobilizacao_attributes_itens_attributes_${indice}_valor_cbs"
                 class="form-control text-right imobilizacao-valor-cbs"
                 step="0.01"
                 min="0"
                 required
                 value="${escaparHtml(item.valorCbs)}">
        </div>
        <div class="form-group col-md-1">
          <label class="control-label">&nbsp;</label>
          <button type="button"
                  class="btn btn-danger btn-block imobilizacao-remover-item"
                  title="${escaparHtml(i18nImobilizacao.removerItem)}">
            <i class="fa fa-trash"></i>
          </button>
        </div>
        ${idHidden}
      </div>
    `;
  }

  function getImobilizacaoHtml() {
    const linhas = imobilizacaoItens.map(getImobilizacaoItemHtml).join('');
    const removidos = imobilizacaoItensRemovidos.map(function(itemId, posicao) {
      const indice = 9000 + posicao;
      return `
        <input type="hidden" name="fiscal_nota_fiscal_evento[imobilizacao_attributes][itens_attributes][${indice}][id]" value="${escaparHtml(itemId)}">
        <input type="hidden" name="fiscal_nota_fiscal_evento[imobilizacao_attributes][itens_attributes][${indice}][_destroy]" value="1">
      `;
    }).join('');
    const imobilizacaoIdHidden = initialImobilizacaoId
      ? `<input type="hidden" name="fiscal_nota_fiscal_evento[imobilizacao_attributes][id]" value="${escaparHtml(initialImobilizacaoId)}">`
      : '';
    return `
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-info" role="alert">
            <i class="fa fa-info-circle"></i>
            <strong>${i18nImobilizacao.informacaoTitulo}</strong>
            ${i18nImobilizacao.informacaoEvento}
          </div>
        </div>
      </div>
      <div id="imobilizacao-itens">${linhas}</div>
      <div class="form-row">
        <div class="form-group col-md-3">
          <button type="button" class="btn btn-default" id="imobilizacao-adicionar-item">
            <i class="fa fa-plus"></i> ${escaparHtml(i18nImobilizacao.adicionarItem)}
          </button>
        </div>
      </div>
      ${removidos}
      ${imobilizacaoIdHidden}
    `;
  }

  function lerImobilizacaoItensDoDom() {
    const linhas = container.querySelectorAll('.imobilizacao-item');
    if (!linhas.length) return;
    imobilizacaoItens = Array.from(linhas).map(function(linha) {
      const idHidden = linha.querySelector('input[name$="[id]"]');
      return {
        id: idHidden ? idHidden.value : "",
        numeroItem: linha.querySelector('.imobilizacao-numero-item').value,
        quantidade: linha.querySelector('.imobilizacao-quantidade').value,
        unidade: linha.querySelector('.imobilizacao-unidade').value,
        valorIbs: linha.querySelector('.imobilizacao-valor-ibs').value,
        valorCbs: linha.querySelector('.imobilizacao-valor-cbs').value
      };
    });
  }

  function renderImobilizacao() {
    if (selectTipoEvento.value !== 'Fiscal::NotaFiscal::Evento::Imobilizacao') return;
    container.innerHTML = getImobilizacaoHtml();
  }

  function resetImobilizacaoItens() {
    imobilizacaoItens.forEach(function(item) {
      if (item.id) imobilizacaoItensRemovidos.push(item.id);
    });
    imobilizacaoItens = [itemPerecimentoVazio()];
  }

  function resetarItensCompraEventoAtivo() {
    resetPerecimentoAdquirenteItens();
    resetImobilizacaoItens();
  }

  function renderizarItensCompraEventoAtivo() {
    renderPerecimentoAdquirente();
    renderImobilizacao();
  }

  function aoTrocarCompra(compraId) {
    if (!itensCompraUrl || !compraId) {
      itensCompra = [];
      resetarItensCompraEventoAtivo();
      renderizarItensCompraEventoAtivo();
      return;
    }
    fetch(`${itensCompraUrl}?compra_id=${encodeURIComponent(compraId)}`, { headers: { 'Accept': 'application/json' } })
      .then(function(resposta) { return resposta.ok ? resposta.json() : []; })
      .then(function(itens) {
        itensCompra = itens;
        resetarItensCompraEventoAtivo();
        renderizarItensCompraEventoAtivo();
      })
      .catch(function(erro) {
        console.error('Erro ao buscar itens da compra:', erro);
        itensCompra = [];
        resetarItensCompraEventoAtivo();
        renderizarItensCompraEventoAtivo();
      });
  }

  container.addEventListener('click', function(evento) {
    if (evento.target.closest('#perecimento-adicionar-item')) {
      lerPerecimentoItensDoDom();
      perecimentoItens.push(itemPerecimentoVazio());
      renderPerecimento();
      return;
    }
    if (evento.target.closest('#perecimento-adquirente-adicionar-item')) {
      lerPerecimentoAdquirenteItensDoDom();
      perecimentoAdquirenteItens.push(itemPerecimentoVazio());
      renderPerecimentoAdquirente();
      return;
    }
    const botaoRemoverAdquirente = evento.target.closest('.perecimento-adquirente-remover-item');
    if (botaoRemoverAdquirente) {
      lerPerecimentoAdquirenteItensDoDom();
      const linhasAdquirente = Array.from(container.querySelectorAll('.perecimento-adquirente-item'));
      const indiceAdquirente = linhasAdquirente.indexOf(botaoRemoverAdquirente.closest('.perecimento-adquirente-item'));
      const itemAdquirente = perecimentoAdquirenteItens[indiceAdquirente];
      if (itemAdquirente && itemAdquirente.id) perecimentoAdquirenteItensRemovidos.push(itemAdquirente.id);
      perecimentoAdquirenteItens.splice(indiceAdquirente, 1);
      if (!perecimentoAdquirenteItens.length) perecimentoAdquirenteItens.push(itemPerecimentoVazio());
      renderPerecimentoAdquirente();
      return;
    }
    if (evento.target.closest('#imobilizacao-adicionar-item')) {
      lerImobilizacaoItensDoDom();
      imobilizacaoItens.push(itemPerecimentoVazio());
      renderImobilizacao();
      return;
    }
    const botaoRemoverImobilizacao = evento.target.closest('.imobilizacao-remover-item');
    if (botaoRemoverImobilizacao) {
      lerImobilizacaoItensDoDom();
      const linhasImobilizacao = Array.from(container.querySelectorAll('.imobilizacao-item'));
      const indiceImobilizacao = linhasImobilizacao.indexOf(botaoRemoverImobilizacao.closest('.imobilizacao-item'));
      const itemImobilizacao = imobilizacaoItens[indiceImobilizacao];
      if (itemImobilizacao && itemImobilizacao.id) imobilizacaoItensRemovidos.push(itemImobilizacao.id);
      imobilizacaoItens.splice(indiceImobilizacao, 1);
      if (!imobilizacaoItens.length) imobilizacaoItens.push(itemPerecimentoVazio());
      renderImobilizacao();
      return;
    }
    const botaoRemover = evento.target.closest('.perecimento-remover-item');
    if (!botaoRemover) return;
    lerPerecimentoItensDoDom();
    const linhas = Array.from(container.querySelectorAll('.perecimento-item'));
    const indice = linhas.indexOf(botaoRemover.closest('.perecimento-item'));
    const item = perecimentoItens[indice];
    if (item && item.id) perecimentoItensRemovidos.push(item.id);
    perecimentoItens.splice(indice, 1);
    if (!perecimentoItens.length) perecimentoItens.push(itemPerecimentoVazio());
    renderPerecimento();
  });

  container.addEventListener('change', function(evento) {
    if (evento.target.classList.contains('perecimento-numero-item')) {
      const opcao = evento.target.selectedOptions[0];
      const linha = evento.target.closest('.perecimento-item');
      const unidadeInput = linha && linha.querySelector('.perecimento-unidade');
      if (opcao && opcao.dataset.unidade && unidadeInput) unidadeInput.value = opcao.dataset.unidade;
      return;
    }
    if (evento.target.classList.contains('perecimento-adquirente-numero-item')) {
      const opcao = evento.target.selectedOptions[0];
      const linha = evento.target.closest('.perecimento-adquirente-item');
      const unidadeInput = linha && linha.querySelector('.perecimento-adquirente-unidade');
      if (opcao && opcao.dataset.unidade && unidadeInput) unidadeInput.value = opcao.dataset.unidade;
      return;
    }
    if (evento.target.classList.contains('imobilizacao-numero-item')) {
      const opcao = evento.target.selectedOptions[0];
      const linha = evento.target.closest('.imobilizacao-item');
      const unidadeInput = linha && linha.querySelector('.imobilizacao-unidade');
      if (opcao && opcao.dataset.unidade && unidadeInput) unidadeInput.value = opcao.dataset.unidade;
    }
  });

  container.addEventListener('click', function(evento) {
    if (evento.target.closest('#fornecimento-adicionar-item')) {
      lerFornecimentoItensDoDom();
      fornecimentoItens.push(itemFornecimentoVazio());
      renderFornecimento();
      return;
    }
    const botaoRemover = evento.target.closest('.fornecimento-remover-item');
    if (!botaoRemover) return;
    lerFornecimentoItensDoDom();
    const linhas = Array.from(container.querySelectorAll('.fornecimento-item'));
    const indice = linhas.indexOf(botaoRemover.closest('.fornecimento-item'));
    const item = fornecimentoItens[indice];
    if (item && item.id) fornecimentoItensRemovidos.push(item.id);
    fornecimentoItens.splice(indice, 1);
    if (!fornecimentoItens.length) fornecimentoItens.push(itemFornecimentoVazio());
    renderFornecimento();
  });

  container.addEventListener('change', function(evento) {
    if (!evento.target.classList.contains('fornecimento-numero-item')) return;
    const opcao = evento.target.selectedOptions[0];
    const linha = evento.target.closest('.fornecimento-item');
    const unidadeInput = linha && linha.querySelector('.fornecimento-unidade');
    if (opcao && opcao.dataset.unidade && unidadeInput) unidadeInput.value = opcao.dataset.unidade;
  });

  const notaFiscalSelect = document.getElementById('evento_nota_fiscal_id');
  const fonteNotaPadrao = notaFiscalSelect ? (notaFiscalSelect.dataset.autocompleteSourcePadrao || notaFiscalSelect.dataset.autocompleteSource || "") : "";
  const fonteNotaDebitoAntecipado = notaFiscalSelect ? (notaFiscalSelect.dataset.autocompleteSourceDebitoAntecipado || "") : "";

  function aoMudarNota() {
    if (notaFiscalSelect) aoTrocarNotaFiscal(notaFiscalSelect.value);
  }

  function bindNotaFiscalChange() {
    if (!notaFiscalSelect) return;
    if (window.jQuery) {
      window.jQuery(notaFiscalSelect).off('change', aoMudarNota).on('change', aoMudarNota);
    } else {
      notaFiscalSelect.addEventListener('change', aoMudarNota);
    }
  }

  function inicializarSelectizeNota() {
    if (!notaFiscalSelect || !window.jQuery || typeof window.jQuery.fn.selectize !== 'function') return;
    const seletor = window.jQuery(notaFiscalSelect);
    if (notaFiscalSelect.selectize) notaFiscalSelect.selectize.destroy();
    seletor.selectize({
      preload: true,
      valueField: 'id',
      labelField: 'label',
      searchField: ['label', 'campos_busca'],
      createFilter: false,
      render: {
        option: function(item, escape) {
          return '<div><span>' + escape(item.label) + '</span></div>';
        }
      },
      load: function(query, callback) {
        const source = notaFiscalSelect.dataset.autocompleteSource;
        if (!source) { callback(); return; }
        window.jQuery.ajax({
          url: source,
          data: { term: query },
          type: 'GET',
          error: function() { callback(); },
          success: function(res) { callback(res); }
        });
      }
    });
    bindNotaFiscalChange();
  }

  function ajustarFonteSeletorNota(tipoEvento) {
    if (!notaFiscalSelect) return;
    const desejada = tipoEvento === 'Fiscal::NotaFiscal::Evento::FornecimentoNaoRealizado'
      ? fonteNotaDebitoAntecipado
      : fonteNotaPadrao;
    if (!desejada || notaFiscalSelect.dataset.autocompleteSource === desejada) return;
    notaFiscalSelect.dataset.autocompleteSource = desejada;
    if (notaFiscalSelect.selectize) inicializarSelectizeNota();
  }

  bindNotaFiscalChange();

  const compraSelect = document.getElementById('evento_compra_id');
  if (compraSelect) {
    const aoMudarCompra = function() { aoTrocarCompra(compraSelect.value); };
    if (window.jQuery) {
      window.jQuery(compraSelect).on('change', aoMudarCompra);
    } else {
      compraSelect.addEventListener('change', aoMudarCompra);
    }
  }

  function updateDocumentSelectorVisibility(tipoEvento) {
    if (!notaFiscalSelector || !compraSelector) return;

    if (!tipoEvento) {
      notaFiscalSelector.style.display = 'none';
      compraSelector.style.display = 'none';
    } else if (tipoEvento === 'Fiscal::NotaFiscal::Evento::AceiteDebitoApuracao' ||
               tipoEvento === 'Fiscal::NotaFiscal::Evento::PerecimentoAdquirente' ||
               tipoEvento === 'Fiscal::NotaFiscal::Evento::Imobilizacao') {
      notaFiscalSelector.style.display = 'none';
      compraSelector.style.display = 'block';
    } else {
      notaFiscalSelector.style.display = 'block';
      compraSelector.style.display = 'none';
    }
  }

  function renderEventoFields(tipoEvento) {
    if (!tipoEvento) {
      container.innerHTML = `<div class="alert alert-info">${escaparHtml(i18nForm.selecioneTipoEvento)}</div>`;
      updateDocumentSelectorVisibility(tipoEvento);
      ajustarFonteSeletorNota(tipoEvento);
      return;
    }

    switch(tipoEvento) {
      case 'Fiscal::NotaFiscal::Evento::DataPrevisaoEntrega':
        container.innerHTML = getDataPrevisaoEntregaHtml(initialDataPrevisao, initialEventoId);
        break;
      case 'Fiscal::NotaFiscal::Evento::PagamentoIntegral':
        container.innerHTML = getPagamentoIntegralHtml(initialIndicadorQuitacao, initialEventoId);
        break;
      case 'Fiscal::NotaFiscal::Evento::AceiteDebitoApuracao':
        container.innerHTML = getAceiteDebitoApuracaoHtml(initialIndicadorAceitacao, initialEventoId);
        break;
      case 'Fiscal::NotaFiscal::Evento::Perecimento':
        container.innerHTML = getPerecimentoHtml();
        break;
      case 'Fiscal::NotaFiscal::Evento::FornecimentoNaoRealizado':
        container.innerHTML = getFornecimentoNaoRealizadoHtml();
        break;
      case 'Fiscal::NotaFiscal::Evento::PerecimentoAdquirente':
        container.innerHTML = getPerecimentoAdquirenteHtml();
        break;
      case 'Fiscal::NotaFiscal::Evento::Imobilizacao':
        container.innerHTML = getImobilizacaoHtml();
        break;
      default:
        container.innerHTML = `<div class="alert alert-info">${escaparHtml(i18nForm.tipoEventoInvalido)}</div>`;
    }
    updateDocumentSelectorVisibility(tipoEvento);
    ajustarFonteSeletorNota(tipoEvento);
  }

  selectTipoEvento.addEventListener('change', function() {
    renderEventoFields(this.value);
  });

  const tipoEventoInicial = selectTipoEvento.value;
  if (tipoEventoInicial) {
    renderEventoFields(tipoEventoInicial);
  }
});
